import { computed } from 'vue';

import useAuth from '@/composables/useAuth';
import { useApiKeysStore } from '@/stores';

import { MAX_API_KEYS_PER_ORG } from './constants';

export default function useApiKeyCreateGate() {
  const apiKeysStore = useApiKeysStore();
  const { hasPermission } = useAuth();

  const canWrite = computed(() => hasPermission('manage:api-keys'));

  const isAtKeyLimit = computed(
    () => apiKeysStore.apiKeys.length >= MAX_API_KEYS_PER_ORG,
  );

  const createDisabledReason = computed(() =>
    !canWrite.value
      ? 'Your role cannot create API keys.'
      : isAtKeyLimit.value
        ? `You've reached the limit of ${MAX_API_KEYS_PER_ORG} API keys per organization. Revoke an existing key to create a new one.`
        : undefined,
  );

  return { canWrite, createDisabledReason };
}
